module.exports = __webpack_public_path__ + "img/SKMJ_place7.9d60f42a.jpg";